import {SvgIconProps} from "@material-ui/core";
import {IconTypes} from "./icons.types";
import DirectionsWalk from "@material-ui/icons/DirectionsWalk";
import Add from "@material-ui/icons/Add";
import AddCircle from "@material-ui/icons/AddCircle";
import ListAltSharpIcon from '@material-ui/icons/ListAltSharp';
import PhoneIcon from '@material-ui/icons/Phone';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import MailIcon from '@material-ui/icons/Mail';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import CheckIcon from '@material-ui/icons/Check';
import Loop from '@material-ui/icons/Loop';
import AutorenewIcon from '@material-ui/icons/Autorenew';


/**
 * DESIGN-V2
 */
import MenuBookIcon from '@material-ui/icons/MenuBook';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
// import AutoGraphIcon from '@material-ui/icons/autograph'; //Reports icon v5
import ShowChartIcon from '@material-ui/icons/ShowChart';
import NewReleasesOutlinedIcon from '@material-ui/icons/NewReleasesOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import LaunchIcon from '@material-ui/icons/Launch';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Timer from '@material-ui/icons/Timer';

// Customer tab
import CallOutlinedIcon from '@material-ui/icons/CallOutlined';
import AccountBoxOutlinedIcon from '@material-ui/icons/AccountBoxOutlined';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

//Booking summary
import DateRangeIcon from '@material-ui/icons/DateRange';
import ScheduleIcon from '@material-ui/icons/Schedule';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import TimerIcon from '@material-ui/icons/Timer';
import EventSeatIcon from '@material-ui/icons/EventSeat';
import LocalOfferOutlinedIcon from '@material-ui/icons/LocalOfferOutlined';

export default class IconsService {

  static getIcon(iconType: IconTypes): (props: SvgIconProps) => JSX.Element {
    switch (iconType) {
      case IconTypes.walkIn:
        return DirectionsWalk;

      case IconTypes.add:
        return Add;

      case IconTypes.addCircle:
        return AddCircle;

      case IconTypes.standbyList:
        return ListAltSharpIcon;

      case IconTypes.phone:
        return PhoneIcon;

      case IconTypes.phoneInTalk:
        return PhoneInTalkIcon;

      case IconTypes.mail:
        return MailIcon;

      case IconTypes.lock:
        return LockIcon;

      case IconTypes.unlock:
        return LockOpenIcon;

      case IconTypes.tick:
        return CheckIcon;

      case IconTypes.loading:
        return Loop;



      /**
       * DESIGN-V2
       */
      case IconTypes.bookings:
        return MenuBookIcon;
      case IconTypes.customers:
        return GroupOutlinedIcon;
      case IconTypes.reports:
        return ShowChartIcon; // to-do, in mui v5, replace with AutoGraphIcon
      case IconTypes.new:
        return NewReleasesOutlinedIcon;
      case IconTypes.settings:
        return SettingsOutlinedIcon;
      case IconTypes.admin:
        return LaunchIcon;
      case IconTypes.fullScreen:
        return FullscreenIcon;

      case IconTypes.stepperLeft:
        return KeyboardArrowLeftIcon;
      case IconTypes.stepperRight:
        return KeyboardArrowRightIcon;

      case IconTypes.autoRenewIcon:
        return AutorenewIcon;

      case IconTypes.timer:
        return Timer;

      case IconTypes.callOutlinedIcon:
        return CallOutlinedIcon;
      case IconTypes.accountBoxOutlinedIcon:
        return AccountBoxOutlinedIcon;
      case IconTypes.mailOutlineIcon:
        return MailOutlineIcon;
      case IconTypes.visibilityOutlinedIcon:
        return VisibilityOutlinedIcon;

      case IconTypes.dateRangeIcon:
        return DateRangeIcon;
      case IconTypes.scheduleIcon:
        return ScheduleIcon;
      case IconTypes.restaurantIcon:
        return RestaurantIcon;
      case IconTypes.timerIcon:
        return TimerIcon;
      case IconTypes.eventSeatIcon:
        return EventSeatIcon;
      case IconTypes.localOfferOutlinedIcon:
        return LocalOfferOutlinedIcon;

    }

    return null;
  }
}
